var _circle, _path, _path2, _path3, _path4, _path5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLike = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 46.5,
    stroke: "#F68D1F",
    strokeWidth: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.83 65.7176H26V47.4136H28.863C28.64 48.7996 28.627 49.7196 28.627 49.7586V63.4816C28.627 64.2456 28.706 64.9886 28.83 65.7176",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5987 41.246C70.8007 41.246 70.9647 41.41 70.9647 41.612V47.939H50.8887V41.612C50.8887 41.41 51.0527 41.246 51.2547 41.246H70.5987Z",
    fill: "#323232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9877 74.607C41.8837 74.607 41.7837 74.596 41.6807 74.593C41.4317 74.587 41.1837 74.578 40.9397 74.556C40.7127 74.535 40.4907 74.501 40.2677 74.466C40.1637 74.45 40.0577 74.437 39.9537 74.418C39.6917 74.369 39.4337 74.31 39.1787 74.244C39.1267 74.23 39.0737 74.218 39.0217 74.203C38.7327 74.123 38.4477 74.034 38.1687 73.932C38.1667 73.931 38.1647 73.93 38.1617 73.929C34.5867 72.616 31.8657 69.516 31.0877 65.718H31.0497C30.9017 64.995 30.8237 64.247 30.8237 63.482V49.761C30.8247 49.618 30.8387 48.71 31.0557 47.414H31.0937C31.7197 43.665 34.0557 36.638 42.7507 35.257C42.8397 35.243 42.9267 35.227 43.0177 35.214C43.2227 35.185 43.4347 35.161 43.6467 35.138C43.8267 35.119 44.0077 35.102 44.1927 35.087C44.3697 35.073 44.5477 35.059 44.7307 35.049C45.0667 35.032 45.4097 35.02 45.7627 35.018C45.8167 35.018 45.8687 35.015 45.9227 35.015C49.5607 35.015 52.4277 33.929 54.4457 31.789C57.7427 28.293 57.4887 23.29 57.4777 23.148C57.4787 23.06 57.5107 21.02 58.7467 21C60.6127 21.02 62.7847 23.751 63.8867 26.322C65.6967 30.546 63.3657 36.335 60.5477 39.049H51.2167C49.8037 39.049 48.6537 40.199 48.6537 41.612V47.939H48.3047C47.6977 47.939 47.2057 48.43 47.2057 49.037V54.226C46.9277 54.429 46.6517 54.634 46.3607 54.822C43.8297 56.449 41.7377 56.841 41.7177 56.845C41.1217 56.951 40.7237 57.519 40.8277 58.115C40.9207 58.649 41.3847 59.025 41.9087 59.025C41.9717 59.025 42.0347 59.019 42.0987 59.008C42.2847 58.976 44.4897 58.56 47.2057 56.899V57.926C47.2057 58.533 47.6977 59.025 48.3047 59.025H48.3527V66.816C48.3527 67.423 48.8447 67.914 49.4507 67.914H49.8207V74.241C49.8207 74.366 49.8407 74.486 49.8577 74.607H41.9877Z",
    fill: "#323232"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9647 74.2409C70.9647 74.4429 70.8007 74.6069 70.5987 74.6069H52.4217C52.2197 74.6069 52.0557 74.4429 52.0557 74.2409V67.9139H70.9647V74.2409Z",
    fill: "#323232"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_897",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 21,
    width: 48,
    height: 54
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 74.607H73.28V21H26V74.607Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_897)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5879 65.718H73.2799V59.025H50.5879V65.718Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4409 56.828H73.2799V50.135H49.4409V56.828Z",
    fill: "#323232"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLike);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Like.b2f8e5ec1e7a183e66437cdc569cd4be.svg";